import { v2_useCart } from '@crocodille/common';
import { useRouter } from '@framework/router';
import { formatCurrency } from '@utils/format';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import CartIcon from '../../icons/cart-icon';
import styles from './cart-floating-button.module.scss';

export interface CartFloatingButtonProps {
  onToggle?: () => void;
}

const CartFloatingButton: React.FC<
  React.PropsWithChildren<CartFloatingButtonProps>
> = ({ onToggle }) => {
  const { t } = useTranslation();
  const { locale } = useRouter();
  const { data: order } = v2_useCart();

  const itemCount = order?.items?.length ?? 0;

  if (itemCount === 0) {
    return null;
  }

  return (
    <button className={cn(styles.button)} onClick={onToggle}>
      <div className={styles.priceContainer}>
        <span className={styles.payPrompt}>{t('cart.pay')}</span>

        <span className={styles.price}>
          {order ? formatCurrency(order.total, 'CZK', locale) : null}
        </span>
      </div>
      <div className={styles.labelContainer}>
        <div className={styles.label}>
          <span className={styles.visibleMobile}>{t('cart.go_to_cart')}</span>
          <span className={styles.visibleDesktop}>
            {t('cart.go_to_cart_desktop')}
          </span>
        </div>

        <div className={styles.icon}>
          <CartIcon className={styles.cartIcon} />
          {itemCount > 0 ? (
            <span className={styles.itemCount}>{itemCount}</span>
          ) : null}
        </div>
      </div>
    </button>
  );
};

export default CartFloatingButton;
